import HeroImg from "../assets/img/HeroImg.jpeg";

const Hero = () => {
  return (
    <div>
      <div className="absolute top-96 font-bold text-2xl text-center w-full">
        <p>
          L'institut eden beauté est heureux de vous acceuillir dans un univers
          dedié à la beauté et au bien etre
        </p>
        <button className="text-sm bg-[#7d4600] px-4 py-2 mt-6 text-white rounded-md">
          Prestations uniquement sur rendez-vous
        </button>
      </div>
      <img className="h-screen object-cover w-full" src={HeroImg} />
    </div>
  );
};

export default Hero;
